var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamecontroller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 33,
    viewBox: "0 0 45 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8568 15.9869C40.1729 8.37441 37.6753 3.51842 33.6723 2.33508C32.897 2.10892 32.0931 1.9961 31.2855 2.00012C28.8245 2.00012 26.8825 3.46442 22.4997 3.46442C18.1168 3.46442 16.1711 2.00012 13.7139 2.00012C12.8726 1.99577 12.0348 2.1085 11.2246 2.33508C7.21603 3.51842 4.73953 8.37899 3.03636 15.9869C1.2975 23.7578 1.61233 29.8978 5.01134 31.0766C7.39083 31.9002 9.51864 30.1971 11.5339 27.6904C13.8219 24.835 16.6397 23.9564 22.4997 23.9564C28.3596 23.9564 31.0677 24.835 33.3593 27.6904C35.3727 30.1989 37.5792 31.881 39.8956 31.0912C43.6497 29.809 43.5966 23.8493 41.8568 15.9869Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7138 9.32162V18.1074",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1067 13.7145H9.32093",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamecontroller);
export default __webpack_public_path__ + "static/media/game controller.250efc12f4d07b590c15eaaa5f4b9cfd.svg";
export { ForwardRef as ReactComponent };